import React, { useState } from 'react';
import {
  Card,
  CardHeader,
  CardContent,
  Avatar,
  Box,
  Button,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { useHistory } from 'react-router-dom';
import Carousel from './../Post/Carousel';
import CarouselCard from './../Post/Carousel/CarosuelCard';
import { useAccount } from '../../contexts/Account';
import { AccountType, SnackbarType } from '../../services/utils/types';
import ACSnackbar from '../ACSnackbar';
import DefaultCompany from '../../icons/building_round.svg';
import eventBus, { eventBusValues } from '../../eventBus';
import CustomIcon from '../../icons/customIcon';
import { likePostCall } from '../../services/company_services';
function getPlainTextFromDraft(draftRaw) {
  if (!draftRaw) return '';
  try {
    const content = JSON.parse(draftRaw);
    if (content.blocks && Array.isArray(content.blocks)) {
      return content.blocks.map((block) => block.text).join('\n');
    }
  } catch (error) {
    console.error('Error parsing draft raw', error);
  }
  return draftRaw;
}

export default function PostCard({ post, company }) {
  const { accountDetails, asLoggedUserDetails, type } = useAccount();
  const {
    postCompanyContact,
    postTitle,
    body,
    primaryAttachment,
    attachments,
    video,
  } = post;
  const [selectedSrc, setSelectedSrc] = useState(primaryAttachment);
  const [selectedPdf, setSelectedPdf] = useState(false);
  const [isAlreadyLiked, setIsAlreadyLiked] = useState(
    post &&
      post.likes &&
      post.likes.filter(
        (element) => element.userId === asLoggedUserDetails.userId
      ).length > 0
  );
  const [justLikedDiff, setJustLikedDiff] = useState(0);
  const history = useHistory();
  const currentCompany =
    type === AccountType.COMPANY ? accountDetails : company;
  const companyImage = postCompanyContact?.imageURL;
  const companyName = postCompanyContact?.companyName;
  const meetingBodyText = getPlainTextFromDraft(body);

  const [expanded, setExpanded] = useState(false);

  const maxCharacters = 500;
  const isLong = meetingBodyText.length > maxCharacters;

  function selectArrayElement(data) {
    if (data === -1) {
      setSelectedSrc('');
    } else {
      setSelectedPdf(attachments[data].url.includes('.pdf'));
      setSelectedSrc(attachments[data]);
    }
  }

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackMessage, setSnackMessage] = useState('');
  const [snackSeverity, setSnackSeverity] = useState(SnackbarType.SUCCESS);

  const isXS = useMediaQuery((theme) => theme.breakpoints.down('xs'));

  function openProfile(event) {
    eventBus.dispatch(eventBusValues.triggerCompanyDrawerAction, {
      company: currentCompany,
    });
    event.stopPropagation();
  }

  const getTruncatedText = (text, maxChars) => {
    const truncated = text.substr(0, maxChars);
    const lastSpace = truncated.lastIndexOf(' ');
    return truncated.substr(0, lastSpace);
  };

  function renderPrimaryAttachment(data) {
    if (data.url.includes('.pdf')) {
      return data.url;
    }
    if (data !== null) {
      const finalUrl = data.thumbnailUrl || data.url;
      return `https://${finalUrl}`;
    }
    return null;
  }

  const displayedText =
    isLong && !expanded
      ? getTruncatedText(meetingBodyText, maxCharacters)
      : meetingBodyText;

  function renderAttachments() {
    if (
      attachments === null ||
      attachments === undefined ||
      attachments.length === 0
    ) {
      return null;
    }
    if (attachments.length > 1 || attachments[0].url.includes('.pdf')) {
      return (
        <Box
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          {selectedPdf ? null : (
            <Box sx={styles.preview} style={{ paddingTop: '9px' }}>
              <img
                src={renderPrimaryAttachment(selectedSrc)}
                alt=""
                style={styles.previewImage}
              />
            </Box>
          )}
          <section style={styles.carouselContainer}>
            <Carousel slideSelected={selectArrayElement}>
              {attachments.map((slide) => {
                return (
                  <CarouselCard
                    key={slide.url}
                    img={renderPrimaryAttachment(slide)}
                    name={slide.name}
                  />
                );
              })}
            </Carousel>
          </section>
        </Box>
      );
    }

    if (attachments.length === 1) {
      return (
        <button
          type="button"
          // onClick={() => bodyClick()}
          // disabled={bodyDisabled}
          style={{ ...styles.buttonBody, paddingTop: '9px' }}
        >
          <Box sx={styles.preview}>
            <img
              src={renderPrimaryAttachment(attachments[0])}
              alt=""
              style={styles.previewImage}
            />
          </Box>
        </button>
      );
    }

    if (attachments.length === 1) {
      return (
        <Box sx={styles.preview}>
          <img
            src={renderPrimaryAttachment(attachments[0])}
            alt=""
            style={styles.previewImage}
          />
        </Box>
      );
    }

    return null;
  }

  function renderVideo() {
    if (video && video.url !== 0) {
      return (
        <div style={styles.videoPreview}>
          <iframe
            src={video.url}
            title="postVideo"
            frameBorder="0"
            allow="autoplay; fullscreen; picture-in-picture"
            style={styles.videoFrame}
          />
        </div>
      );
    }
    return null;
  }

  function singularPlural(number, isComment = false) {
    if (number === 1) {
      return isComment ? 'Comment' : 'Like';
    }
    return isComment ? 'Comments' : 'Likes';
  }

  function postLikeAction(e) {
    e.stopPropagation();
    if (post.companyId === accountDetails.id) {
      setSnackMessage('Not allowed to like your own content');
      setSnackSeverity(SnackbarType.ERROR);
      setSnackbarOpen(true);
    } else {
      if (isAlreadyLiked) {
        setIsAlreadyLiked(false);
        setJustLikedDiff(-1);
      } else {
        setIsAlreadyLiked(true);
        setJustLikedDiff(1);
      }
      likePostCall({
        ACCOUNT_TYPE:
          type === AccountType.COMPANY
            ? AccountType.CONTACT
            : AccountType.ADVISOR,
        USER_ID: asLoggedUserDetails.userId,
        POST_ID: post.id,
      });
    }
  }

  const styles = {
    avatarContainer: {
      borderRadius: '8px',
      backgroundColor: '#F4F8FF',
      minWidth: '300px',
      height: '64px',
    },
    avatarContainerName: {
      fontSize: '14px',
      fontWeight: 600,
      lineHeight: '130%',
      color: '#001030',
      mb: '2px',
    },
    mainContainer: {
      display: 'flex',
      width: '100%',
      height: 'fit-content',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
      flexDirection: 'column',
    },
    group: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      height: 'fit-content',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
    },
    bodyDashboard: {
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '14px',
      display: 'inline-block',
      width: '100%',
      maxHeight: '107px',
      overflow: 'hidden',
      position: 'relative',
      overflowWrap: 'break-word',
      wordBreak: 'break-word',
      hyphens: 'auto',
      color: '#232B35',
    },
    bodyIndividual: {
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '14px',
      maxWidth: '100%',
      display: 'inline-block',
      height: 'fit-content',
      overflowWrap: 'break-word',
      wordBreak: 'break-word',
      hyphens: 'auto',
      color: 'info.dark',
    },
    more: {
      display: 'flex',
      alignSelf: 'flex-end',
      height: 'fit-content',
      width: '100px',
      bottom: '0px',
      right: '0px',
      background:
        'linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 7%, rgba(255,255,255,1) 100%)',
    },
    text: {
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '14px',
      color: '#3676F4',
    },
    preview: {
      width: '100%',
      height: '310px',
      borderColor: 'secondary.main',
      borderRadius: '5px',
      marginBottom: '10px',
      display: 'flex',
      overflowX: 'scroll',
      '&::-webkit-scrollbar': {
        height: '10px',
        WebkitAppearance: 'none',
      },
      '&::-webkit-scrollbar-thumb': {
        borderRadius: '4px',
        backgroundColor: 'rgba(0,0,0,.5)',
        WebkitBoxShadow: '0 0 1px rgba(255,255,255,.5)',
      },
    },
    videoPreview: {
      position: 'relative',
      paddingBottom: '36.25%',
      height: isXS ? '200px' : '300px',
      maxWidth: '900px',
      alignSelf: 'center',
      width: 'auto',
      overflow: 'hidden',
      marginTop: 10,
    },
    stickyVideoPreview: {
      position: 'fixed',
      top: '0px',
      left: '0px',
      paddingBottom: '100%',
      zIndex: 2,
      width: '100%',
      overflow: 'hidden',
    },
    videoFrame: {
      position: 'absolute',
      top: '0px',
      left: '0px',
      width: '100%',
      height: '100%',
    },
    grayOverlay: {
      position: 'absolute',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
      zIndex: 1,
      height: '100%',
      opacity: '0.7',
      backgroundColor: 'black',
    },
    playButton: {
      width: '300px',
      opacity: 1,
    },
    LockedVideoFrame: {
      position: 'absolute',
      top: '0px',
      left: '0px',
      width: '100%',
      height: '100%',
      pointerEvents: 'none',
    },
    previewImage: {
      // height: '100%',
      borderRadius: '5px',
      margin: '0px',
      paddin: '0px',
      height: '280px',
      width: 'auto',
    },
    carouselContainer: {
      display: 'flex',
      flexDirection: 'column',
      minHeight: '95px',
      width: '100%',
    },
    buttonBody: {
      borderRadius: '5px',
      border: 'none',
      outline: 'none',
      cursor: 'pointer',
      '&:disabled': {
        cursor: 'default',
      },
      backgroundColor: 'transparent',
      width: '100%',
      margin: '0px',
      padding: '0px',
    },
  };
  return (
    <>
      <Card
        sx={{
          width: '100%',
          margin: '0 auto',
          mt: 2,
          borderRadius: '8px',
          cursor: 'pointer',
        }}
        onClick={(e) => {
          history.push(`/post/${post.id}`, {
            companySlug: company?.slug,
          });
        }}
      >
        {!isXS && (
          <CardHeader
            avatar={
              <Avatar
                src={companyImage || DefaultCompany}
                alt={companyName}
                sx={{ width: 40, height: 40 }}
                onClick={openProfile}
              />
            }
            title={
              <Typography
                onClick={openProfile}
                sx={{
                  fontSize: '16px',
                  fontWeight: 600,
                  color: '#001030',
                }}
              >
                {companyName}
              </Typography>
            }
            sx={{
              borderBottom: '1px solid #eee',
              height: '82px',
              '& .MuiCardHeader-action': {
                alignSelf: 'center',
              },
            }}
            action={
              <Button
                // startIcon={<CalendarTodayIcon />}
                // onClick={handleViewDetails}
                variant="contained"
                sx={{
                  borderRadius: '8px',
                  textTransform: 'none',
                  fontSize: '14px',
                  fontWeight: 600,
                  lineHeight: '18px',
                  height: '42px',
                  width: '171px',
                  marginRight: '10px',
                  backgroundColor: '#2B71F6',
                }}
              >
                View Details
              </Button>
            }
          />
        )}
        {isXS && (
          <>
            <Box
              sx={{
                marginTop: '12px',
                px: '15px',
                display: 'flex',
                flexDirection: 'row',
              }}
            >
              <Avatar
                src={companyImage || DefaultCompany}
                alt={companyName}
                sx={{
                  marginTop: '12px',
                  height: 72,
                  width: 72,
                  backgroundColor: 'white',
                  borderRadius: '12px',
                  display: 'flex',
                }}
              />
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'flex-start',
                  width: '100%',
                  marginLeft: '15px',
                }}
              >
                <Typography
                  sx={{
                    fontSize: '14px',
                    fontWeight: 600,
                    color: '#001030',
                    my: '8px',
                    textAlign: 'center',
                  }}
                  onClick={openProfile}
                  gutterBottom
                >
                  {companyName}
                </Typography>
                {/* <PillSection isMobile /> */}
                <Button
                  variant="contained"
                  sx={{
                    borderRadius: '8px',
                    textTransform: 'none',
                    fontSize: '12px',
                    fontWeight: 600,
                    lineHeight: '18px',
                    height: '25px',
                    // width: '100%',
                    marginRight: '10px',
                    // marginTop: '20px',
                    backgroundColor: '#2B71F6',
                  }}
                >
                  View Details
                </Button>
              </Box>
            </Box>
          </>
        )}

        <CardContent>
          <Typography
            sx={{
              fontSize: isXS ? '18px' : '24px',
              fontWeight: 600,
              color: '#001030',
            }}
            gutterBottom
          >
            {postTitle}
          </Typography>
          {/* {!isXS && <PillSection />} */}
          <Typography
            sx={{
              fontSize: '14px',
              fontWeight: 400,
              color: '#4D586F',
            }}
            mb={3}
            whiteSpace="pre-line"
          >
            {displayedText}
            {isLong && (
              <>
                {!expanded && '... '}
                <Button
                  onClick={(event) => {
                    setExpanded(!expanded);
                    event.stopPropagation();
                  }}
                  sx={{
                    textTransform: 'none',
                    fontSize: '14px',
                    fontWeight: 600,
                    padding: 0,
                    minWidth: 0,
                  }}
                >
                  {expanded ? 'view less' : 'view more'}
                </Button>
              </>
            )}
          </Typography>
          {renderAttachments()}
          {renderVideo()}
          <Box display="flex" flexWrap="wrap" gap={2}>
            {postCompanyContact && (
              <Box
                display="flex"
                alignItems="center"
                p={1}
                sx={styles.avatarContainer}
              >
                {postCompanyContact.companyContactImage ? (
                  <Avatar
                    src={postCompanyContact.companyContactImage}
                    alt={postCompanyContact.name}
                    sx={{ width: 40, height: 40, mr: 1 }}
                  />
                ) : (
                  <Avatar sx={{ width: 40, height: 40, mr: 1 }}>
                    {/* fallback */}
                  </Avatar>
                )}
                <Box>
                  <Typography sx={styles.avatarContainerName}>
                    {postCompanyContact.name}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    {postCompanyContact.title}, {postCompanyContact.companyName}
                  </Typography>
                </Box>
              </Box>
            )}
          </Box>
          <Box
            display="flex"
            justifyContent={isXS ? 'center' : 'space-between'}
            alignItems="center"
            mt={2}
            sx={{
              flexDirection: 'row',
              gap: isXS ? 1 : 0,
              maxWidth: isXS ? '100%' : '200px',
            }}
          >
            <button
              style={{
                border: 'none',
                display: 'flex',
                outline: 'none',
                backgroundColor: 'transparent',
                flexShrink: 0,
                padding: '0px',
                justifyContent: 'center',
                alignItems: 'center',
                cursor: 'pointer',
                width: 'fit-content',
                color: isAlreadyLiked
                ? '#1663F7'
                : '#232B35',
                '&:disabled': {
                  cursor: 'default',
                },
              }}
              onClick={postLikeAction}
              id="likeButton"
              type="button"
              // disabled={disabled}
            >
              <CustomIcon
                iconname="like"
                style={{
                  color:
                  isAlreadyLiked
                      ? '#1663F7'
                      : '#232B35',
                  fontSize: '20px',
                  marginRight: '10px',
                  height: '26px',
                }}
              />
              {`${post.likesCount + justLikedDiff} ${singularPlural(post.likesCount + justLikedDiff)}`}
            </button>
            <button
              style={{
                border: 'none',
                display: 'flex',
                outline: 'none',
                backgroundColor: 'transparent',
                flexShrink: 0,
                padding: '0px',
                justifyContent: 'center',
                alignItems: 'center',
                cursor: 'pointer',
                width: 'fit-content',
                '&:disabled': {
                  cursor: 'default',
                },
              }}
              // onClick={() => onClick()}
              id="likeButton"
              type="button"
              // disabled={disabled}
            >
              <CustomIcon
                iconname="comments"
                style={{
                  color:
                    post &&
                    post.contributors &&
                    post.contributors.filter(
                      (element) => element.id === asLoggedUserDetails.userId
                    ).length > 0
                      ? '#1663F7'
                      : '#232B35',
                  fontSize: '24px',
                  marginRight: '10px',
                  height: '26px',
                }}
              />
              {`${post.responsesCount} ${singularPlural(
                post.responsesCount,
                true
              )}`}
            </button>
          </Box>
          <ACSnackbar
            style={{ marginTop: '50px' }}
            open={snackbarOpen}
            text={snackMessage}
            severity={snackSeverity}
            onClose={() => {
              setSnackbarOpen(false);
            }}
            autoHideDuration={5000}
          />
        </CardContent>
      </Card>
    </>
  );
}
